'use strict';
var $defineProperty = require(67)
  , createDesc      = require(85);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};